import { Factory } from 'rosie';

import '../conversation_item_factory';

Factory.define('VoiceAIMessage').attr('type', 'VOICE_AI_MESSAGE');

Factory.define('VoiceAIMessageDefaults')
    .extend('VoiceAIMessage')
    .attr('automationSessionId', 'automation-session-id')
    .attr('callId', 'call-id')
    .attr('companyNumber', '+14153334444')
    .attr('customerNumber', '+6013299800')
    .attr('body', 'Hello! Im your local AI assistant')
    .attr('status', 'PLAYED');

Factory.define('VoiceAIMessageItem')
    .extend('ConversationItem')
    .attr('content', ['content'], content => Factory.attributes('VoiceAIMessage', content));

Factory.define('VoiceAIMessageItemWithDefaults')
    .extend('ConversationItemWithDefaults')
    .attr('content', ['content'], content => Factory.attributes('VoiceAIMessageDefaults', content));
